import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y } from 'swiper/modules';
import 'swiper/css';

import './UpcomingEventsCarousel.css';
import './UpcomingEvents.css';

import { SlCalender } from 'react-icons/sl';
import { IoMdStopwatch } from 'react-icons/io';
import { LiaGlassCheersSolid } from 'react-icons/lia';
import { PiUsers } from 'react-icons/pi';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import { MdModeEdit } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";

const UpcomingEventsCarousel = ({ leads = [], setActiveIndex, setModalOpen, istableleads, }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const swiperRef = useRef(null);

    const getTotalGuests = (item) => {
        const male = parseInt(item.male || 0, 10);
        const female = parseInt(item.female || 0, 10);
        const kids = parseInt(item.kids || 0, 10);
        return male + female + kids;
    };


    useEffect(() => {
        if (leads.length && leads[0]?.id) {
            setActiveIndex(leads[0].id);
        }
    }, [leads, setActiveIndex ]);




    if (!leads.length) {
        return <div className="ue-no-events">No upcoming events</div>;
    }

    return (
        <>
            <div className="ue-custom-carousel">

                <button
                    className="ue-carousel-btn ue-carousel-btn-left"
                    onClick={() => swiperRef.current?.slidePrev()}
                >
                    <MdArrowBackIos />
                </button>

                <Swiper
                    modules={[A11y]}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    onSlideChange={(swiper) => {
                        setCurrentIndex(swiper.activeIndex);
                        const activeItem = leads[swiper.activeIndex];
                        if (setActiveIndex && activeItem?.id) {
                            setActiveIndex(activeItem.id);
                        }
                    }}
                    slidesPerView={1}
                    navigation={false}
                    className='upcoming-events-header-swiper'
                >
                    {leads.map((event, index) => (
                        <SwiperSlide key={index} className='upcoming-events-header-slide-swiper'>
                            <div className="upcoming-events-header-content">
                                <div className='ue-carousel-header-content-edit'>
                                    <div className="ue-carousel-counter">
                                        {currentIndex + 1}/{leads.length}
                                    </div>
                                    <div className='ue-carousel-edit-btn' title='Edit' >
                                        <p onClick={() => setModalOpen(true)}><MdModeEdit /></p>
                                    </div>
                                </div>
                                <div className="upcoming-events-header-list">
                                    <SlCalender />
                                    <p>
                                        Party Date:{' '}
                                        <span className="upcoming-events-header-list-span">{event.party_date}</span>
                                    </p>
                                </div>

                                <div className="upcoming-events-header-list">
                                    <IoMdStopwatch />
                                    <p>
                                        Party Time Slot:{' '}
                                        <span className="upcoming-events-header-list-span">{event.party_time}</span>
                                    </p>
                                </div>

                                {istableleads && <div className="upcoming-events-header-list">
                                    <IoLocationOutline />
                                    <p>
                                        Location:{' '}
                                        <span className="upcoming-events-header-list-span">{event.area}, {event.city}</span>
                                    </p>
                                </div>
                                }

                                {!istableleads && <div className="upcoming-events-header-list">
                                    <LiaGlassCheersSolid />
                                    <p>
                                        Package Type:{' '}
                                        <span className="upcoming-events-header-list-span">{event.title}</span>
                                    </p>
                                </div>
                                }

                                <div className="upcoming-events-header-list">
                                    <PiUsers />
                                    <p>
                                        Pax:{' '}
                                        <span className="upcoming-events-header-list-span">
                                            {getTotalGuests(event)} Guests
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <button
                    className="ue-carousel-btn ue-carousel-btn-right"
                    onClick={() => swiperRef.current?.slideNext()}
                >
                    <MdArrowForwardIos />
                </button>


            </div >
        </>
    );
};

export default UpcomingEventsCarousel;
